import { h } from 'preact'
import Button from 'components/Button'
import EndUserAvatar from 'components/EndUserAvatar'
import { usePublicProfiles } from 'lib/membershipAppStateHooks'
import { useAppState } from 'lib/appState'
// import { useAppState } from 'lib/appState'


export function ThreadRepliesNumber({ replyCount, replies, fromMe, openThreadRepliesModal, chatChannelUid, uid }) {

  const publicProfileDids = replies.reduce((acc, reply) => {
    acc.add(reply.creatorUserDid)
    return acc
  }
  , new Set())

  const { publicProfiles } = usePublicProfiles(
    [...publicProfileDids],
    'ChatMessage'
  )


  const { takeAction } = useAppState(
    {
      [
      `chat:channel:${chatChannelUid}:thread:open`
      ]: 'chatThread'
    },
    'ThreadRepliesNumber'
  )


  return <div className="OrganizationChatPage-Bubble-ThreadRepliesNumber">
    {
      publicProfiles && publicProfiles.length > 0 &&
      <div className={`OrganizationChatPage-Bubble-ThreadRepliesNumber-avatars ${fromMe ? 'fromMe' : ''}`}>
        {publicProfiles.slice(0, 3).map((publicProfile, i) => {
          return <EndUserAvatar
            key={i}
            publicProfile={publicProfile}
            size="tn"
          />
        })}
        <Button className="OrganizationChatPage-Bubble-ThreadRepliesNumber-avatars-count"
          onClick={() => {
            openThreadRepliesModal()
            takeAction('chat.openThread', chatChannelUid, uid)
          }}
        >
          {replyCount} {replyCount === 1 ? 'reply' : 'replies'}
        </Button>
      </div>}
  </div>
}
